// src/components/WeekAgenda.tsx
import React, { useState, useEffect } from 'react';
import { CustomColorWeekItem } from '../../functions/date/colorofTask/colorTask';
import { CustomModalWeek } from './customModal';
import { guid } from '@progress/kendo-react-common';
import { sampleDate } from "../../Mock/dataPlanningMock";
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { Link } from 'react-router-dom';
import { formatDate, getEndOfWeek, getStartOfWeek, sortTasksByTime } from '../../functions/date/getFirstLastDay';
import { useConf } from '../../context/account/paramsAccount';
import { useError } from '../../context/erreur/erreurContext';
import { hookApi } from '../../hook/presta/affichePrestaHook';
import { apiPostWToken } from '../../api/apiPost';
import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns";

const columns = [
    { field: "soc_nom", header: "Nom de la société", width: "30%" },
    { field: "sit_nom", header: "Nom site", width: "30%" },
];
const daysOfWeek = ['lun', 'mar', 'mer', 'jeu', 'ven', 'sam', 'dim'];

export interface Task {
    v_cnt1_civ_nom: string;
    v_cnt1_tel_fixe: string;
    v_cnt1_tel_mobile: string;
    v_cnt2_id: string;
    v_cnt2_civ_nom: string;
    v_cnt2_tel_fixe: string;
    v_cnt2_tel_mobile: string;
    cli_tel_fixe: string;
    cli_tel_mobile: string;
    v_desc: string;
    v_cli_civ_nom: string;
    v_nbre_convive: string;
    v_num_piece: string;
    v_rad_avancement: string;
    v_lieu_civ_nom: string;
    v_lib_avancement: string;
    v_type_presta: string;
    id: string;
    start: Date;
    startTimezone: string;
    end: Date;
    endTimezone: string;
    isAllDay: string;
    title: string;
    description: string;
    recurrenceRule: string;
    recurrenceId: string;
    recurrenceExceptions: string;
    modeVente: string;
    roomId: string;
    ownerID: string;
    personId: string;
}

interface DayTasks {
    [key: string]: Task[];
}

function isValidDate(d: Date) {
    return d instanceof Date && !isNaN(d.getTime());
}

const WeekAgenda = () => {
    const { conf, setConf }: any = useConf()
    const { showError } = useError();
    const [dateData, setDateData]: any = useState([])
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(currentDate);
    const [startOfWeek, setStartOfWeek] = useState(selectedDate.toISOString().split('T')[0])
    const [endOfWeek, setEndOfWeek] = useState(selectedDate.toISOString().split('T')[0])
    const [tasks, setTasks] = useState<DayTasks>({});
    const [selectedTask, setSelectedTask] = useState<Task | null>(null);
    const [newDate, setNewDate]: any = useState(null)
    interface Site {
        sit_couleur: null
        sit_id: number
        sit_nom: string
        soc_id: number
        soc_nom: string
        v_ordre: string
    }

    const [site, setSite] = useState<Site | null>(null);
    const [dataTab, setDataTab] = useState([])
    const allSitesOption = { sit_nom: "Tous les sites", soc_id: null, soc_nom: "Tous les sites", sit_id: null };
    const fullDataTab = [allSitesOption, ...dataTab];

    useEffect(() => {
        if (conf?.user?.site?.soc_id) {
            setSite(conf.user.site);
        }
    }, [conf?.user?.site?.soc_id]);
    useEffect(() => {
        const data = null
        if (conf.token !== '' && conf.token !== undefined) {
            apiPostWToken("/posts/choix-site", data, conf.token, conf, setConf, showError).then((response: any) => {
                setDataTab(response)
            })
        }
    }, [conf.token])
    useEffect(() => {
        if (!conf.token || !site) return;
        const startOfWeek = getStartOfWeek(selectedDate);
        const endWeek = getEndOfWeek(selectedDate);
        setEndOfWeek(endWeek.toISOString().split('T')[0]);
        setStartOfWeek(startOfWeek.toISOString().split('T')[0]);

        const dateData = { e_date_deb: startOfWeek, e_date_fin: endOfWeek, e_soc_id: site?.soc_id, url: conf.user.url };
        hookApi('/posts/planning', dateData, conf, setConf, setNewDate, showError)

    }, [selectedDate, conf.token, conf?.user?.site?.soc_id,site]);
    // /posts/generate-etat
    useEffect(() => {
        const startOfWeek = getStartOfWeek(selectedDate);
        if (newDate !== null) {
            const weekDates = Array.from({ length: 7 }, (_, i) => {
                const date = new Date(startOfWeek);
                date.setDate(startOfWeek.getDate() + i);
                return formatDate(date);
            });
            const processedData = (newDate);
            setDateData(processedData)
            const datet = sampleDate(processedData);

            const sortedTasks: DayTasks = weekDates?.reduce((acc, date) => {
                acc[date] = sortTasksByTime(datet?.filter((task: any) => formatDate(new Date(task.start)) === date));
                return acc;
            }, {} as DayTasks);
            setTasks(sortedTasks);
        }
    }, [newDate])
    const handleTaskClick = (task: Task) => {
        setSelectedTask(task);
    };
    const handleCloseModal = () => {
        setSelectedTask(null);
    };
    function changeDate(value: Date) {
        const date = new Date(value);

        if (!isValidDate(date)) {
            // La date est invalide => on peut afficher une erreur ou juste ne rien faire
            console.error("Date invalide :", value);
            return;
        }

        setSelectedDate(date);

        const startOfWeek = getStartOfWeek(date);
        const endWeek = getEndOfWeek(date);

        setEndOfWeek(endWeek.toISOString().split('T')[0]);
        setStartOfWeek(startOfWeek.toISOString().split('T')[0]);
    }
    function isValidDate(d: Date) {
        return d instanceof Date && !isNaN(d.getTime());
    }

    return (
        <div>

            <div className='containerDatePicker'>
                <div className='datePicker'>
                    <div>
                        <MultiColumnComboBox
                            data={fullDataTab}
                            columns={columns}
                            textField={"sit_nom"}
                            placeholder={conf?.user?.site?.sit_nom ? conf.user?.site?.sit_nom : "Selectionnez une valeur"}
                            onChange={(e: any) => { setSite(e.value) }} />
                    </div>
                    <LocalizationProvider language="fr-FR">
                        <IntlProvider locale="fr">
                            <DatePicker placeholder="date" defaultValue={selectedDate} onChange={(e: any) => {
                                changeDate(e.target.value)
                            }} />
                        </IntlProvider>
                    </LocalizationProvider>
                </div>
                <div className='weekLink'>
                    <Link className='buttonChangeCalendarMonth semaine' to='/planning/semaine'>Semaine</Link>
                    <Link className='buttonChangeCalendarMonth' to='/planning'>Mois</Link>
                    <Link className='buttonChangeCalendarMonth' to='/planning/jour'>Jour</Link>
                </div>
            </div>
            <div className='weekContainer' >
                {Object.keys(tasks).map((date, index) => (
                    <div key={guid()} className='weekDate'>
                        <h2>{daysOfWeek[index]}. {date}</h2>
                        <ul className='ulWeek'>
                            {(tasks[date] || []).map((task) => {
                                const { pastilleColor } = CustomColorWeekItem(task);
                                return (
                                    <li key={task.id} className='task' onClick={() => handleTaskClick(task)}>

                                        <div className='headerTask'>
                                            <span style={{ color: 'rgb(150, 189, 13)', fontWeight: 'bold' }}>
                                                {new Date(task.start).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                            </span>
                                            <span>
                                                {task.v_num_piece}
                                            </span>
                                        </div>
                                        <div className='bodyTask'>
                                            <span style={{ color: 'blue', fontWeight: 'bold' }}>
                                                {task.v_desc}
                                            </span>
                                            <span style={{ color: 'purple', fontWeight: 'italic' }}>
                                                {task.v_lib_avancement}
                                            </span>
                                            <span style={{ color: 'black', fontWeight: 'bold' }}>
                                                {task.v_cli_civ_nom}
                                            </span>
                                            <span style={{ color: 'red', fontWeight: '900' }}>
                                                {task.modeVente}
                                            </span>

                                            <span className="pastilleweek" style={{ backgroundColor: pastilleColor }}></span>
                                        </div>
                                        <div className='footerTask'>
                                            <span>
                                                {task.v_lieu_civ_nom}
                                            </span>

                                            {
                                                task.v_nbre_convive === null ?
                                                    "" : <span>{task.v_nbre_convive}personnes</span>
                                            }
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
            </div>
            {selectedTask && (
                <>
                    <div className="overlay"></div>
                    <div className="modalDC" onClick={handleCloseModal} >
                        <div className="titleContainer">
                            <div className='backgroundDC'>
                                <CustomModalWeek dataItem={selectedTask} onClose={handleCloseModal} />
                            </div>
                        </div>
                    </div>
                </>

            )}
        </div>
    );
};

export default WeekAgenda;
